import {Entity, Cartesian3, PropertyBag} from 'cesium';
import {Label as getStyle, setEntityStyle} from '../renderer';

export default class Point extends Entity {
    constructor(options) {
        const {geometry, properties, style, text, ...other} = options;

        let props = {
            clampToGround: true,
            position: Cartesian3.fromDegrees(...geometry),
            properties: new PropertyBag(properties),
            ...other,
        };

        if (text) {
            props.label = getStyle({text, ...style});
        }

        super(props);
    }

    setGeometry(geometry) {
        this.position.setValue(Cartesian3.fromDegrees(...geometry));
    }

    setProperties(properties) {
        this.properties.setValue(new PropertyBag(properties));
    }

    setStyle(style) {
        setEntityStyle(this.point, getStyle({ ...style }));
    }
}
